import { render, staticRenderFns } from "./CardIndicador.vue?vue&type=template&id=703b72d2&"
import script from "./CardIndicador.vue?vue&type=script&lang=ts&"
export * from "./CardIndicador.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports